<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">{{ title }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.close()"
  >
    Close
  </button>
</div>
<div
  class="modal-body"
  hsDraggable="modal-dialog"
  *nfLoader="corporateActionDetailsLoading"
>
  <form [formGroup]="corporateActionForm" class="corporate-action-form">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-12">
            <nf-form-control label="Type">
              <ng-select formControlName="type" [items]="types">
                <ng-template ng-option-tmp let-item="item">
                  <div
                    container="body"
                    class="ellipsis"
                    [title]="
                      item?.forRemoval
                        ? 'Type has been scheduled for removal'
                        : ''
                    "
                  >
                    {{ item != null ? item.label : '' }}
                    {{ item?.forRemoval ? ' (DEPRECATED)' : '' }}
                  </div>
                </ng-template>
              </ng-select>
            </nf-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <nf-form-control>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  class="custom-control-input"
                  id="mandatory"
                  formControlName="mandatory"
                  type="radio"
                  value="mandatory"
                  required
                />
                <label class="custom-control-label" for="mandatory"
                  >Mandatory</label
                >
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  class="custom-control-input"
                  id="voluntary"
                  formControlName="mandatory"
                  type="radio"
                  value="voluntary"
                  required
                />
                <label class="custom-control-label" for="voluntary"
                  >Voluntary</label
                >
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  class="custom-control-input"
                  id="unknown"
                  formControlName="mandatory"
                  type="radio"
                  value="unknown"
                  required
                />
                <label class="custom-control-label" for="unknown"
                  >Unknown</label
                >
              </div>
            </nf-form-control>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6">
            <nf-form-control
              compact
              label=" {{
                corporateActionForm.controls.type?.value &&
                corporateActionForm.controls.type?.value.dateLabel
                  ? corporateActionForm.controls.type.value.dateLabel
                  : 'Effective Date'
              }}"
            >
              <input
                formControlName="effectiveDate"
                class="input"
                type="date"
              />
            </nf-form-control>
          </div>
          <div class="col-sm-6">
            <nf-form-control
              label="Jira Issue Key"
              [customErrorMessages]="jiraStatusValidationMessage"
            >
              <input
                id="jiraIssueKey"
                class="form-control"
                formControlName="jiraIssueKey"
                type="text"
                placeholder="XYZ-123"
              />
            </nf-form-control>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <nf-form-control>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  class="custom-control-input"
                  id="jiraStatus"
                  formControlName="manualStatus"
                  type="radio"
                  [value]="USE_JIRA_STATUS"
                  required
                />
                <label class="custom-control-label" for="jiraStatus"
                  >Use Jira Status</label
                >
                <span
                  class="mdi mdi-information"
                  id="override-jira-status"
                  ngbTooltip="Only use these options to override the Jira status"
                ></span>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  class="custom-control-input"
                  id="reconReady"
                  formControlName="manualStatus"
                  type="radio"
                  value="READY_FOR_RECON"
                />
                <label class="custom-control-label" for="reconReady"
                  >Ready for Recon</label
                >
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  class="custom-control-input"
                  id="idca"
                  formControlName="manualStatus"
                  type="radio"
                  value="IDCA_PROCESSED"
                />
                <label class="custom-control-label" for="idca"
                  >IDCA Processed</label
                >
              </div>
            </nf-form-control>
          </div>
        </div>
      </div>
    </div>

    <nf-form-control label="Notes">
      <textarea
        rows="3"
        class="form-control"
        formControlName="notes"
      ></textarea>
    </nf-form-control>
    <div class="row">
      <div class="col-sm-5">
        <nf-form-control label="Parent CUSIPs"> </nf-form-control>
      </div>
      <div class="col-sm-5">
        <nf-form-control label="Child CUSIPs"> </nf-form-control>
      </div>
      <div class="col-sm-2">
        <span
          class="mdi mdi-plus-circle text-success"
          (click)="addSecurityGroup()"
        ></span>
      </div>
    </div>
    <span formArrayName="securityGroupForms">
      <div
        class="row"
        *ngFor="let control of securityGroupForms.controls; let i = index"
        [formGroupName]="i"
      >
        <div class="col-sm-5">
          <nf-form-control [customErrorMessages]="securityValidationMessage">
            <input
              id="parentCusips"
              class="form-control"
              formControlName="parentCusips"
              type="text"
            />
          </nf-form-control>
        </div>
        <div class="col-sm-5">
          <nf-form-control>
            <input
              id="childCusips"
              class="form-control"
              formControlName="childCusips"
              type="text"
            />
          </nf-form-control>
        </div>
        <div class="col-sm-2">
          <span
            class="mdi mdi-minus-circle text-danger"
            (click)="deleteSecurityGroup(i)"
          ></span>
        </div>
      </div>
    </span>
    <div>
      <div class="d-flex justify-content-center">
        <button nf-button (click)="openBulkModal()">Bulk Entry</button>
      </div>
    </div>
  </form>
</div>
<div
  class="modal-footer d-flex justify-content-between"
  hsDraggable="modal-dialog"
>
  <div class="left-controls">
    <label
      *ngIf="isEdit()"
      class="checkbox"
      title="Force any existing issues for this corporate action that have been resolved to re-flag"
    >
      <nf-checkbox
        [formControl]="forceReflag"
        label="Re-Flag Closed Issues"
      ></nf-checkbox>
    </label>
  </div>
  <div class="right-controls">
    <button nf-button="cancel" (click)="activeModal.close()"></button>
    <button
      nf-button="save"
      (click)="openSaveModal()"
      type="submit"
      [disabled]="!corporateActionForm.valid"
    ></button>
  </div>
</div>
